import { createFileRoute } from '@tanstack/react-router';

import { preloadProgressData } from 'hooks/useQuery/useQueryProgressData';
import { preloadRegisteredApps } from 'hooks/useQuery/useQueryRegisteredApps';

import { AppInfoView } from 'views/AppInfoView';

export const Route = createFileRoute('/_auth/_buttonView/_layout/info/$id')({
  component: AppInfoView,
  staticData: {
    disableLayout: true,
  },
  beforeLoad: async ({ context, params }) => {
    const { queryClient } = context;

    const [appRegistration] = await preloadRegisteredApps(queryClient, params?.id);

    if (appRegistration !== undefined) {
      context.hideButtonBarButtons = ['retain', 'resource-promote', 'resource-sell', 'directory', 'search'];

      const [progress] = await preloadProgressData(queryClient, [params?.id]);

      if (progress?.chapterCompletion === 100) {
        context.hideButtonBarButtons = ['training'];
      }
    } else {
      context.hideButtonBarButtons = ['search'];
    }

    return context;
  },
  errorComponent: () => {
    <h1>{'User not logged in'}</h1>;
  },
});
